import { z } from 'zod';
import * as auth from '../../primitives/auth';
import { RequiredMessage } from '../../validation/messages';

export const changePasswordBlock = z
  .object({
    currentPassword: auth.currentPassword.schema,
    newPassword: auth.newPassword.schema,
    repeatPassword: z.string().min(1, RequiredMessage),
  })
  .refine((d) => d.newPassword === d.repeatPassword, {
    message: 'Passwords must match',
    path: ['repeatPassword'],
  });

export const securityQuestionsBlock = z.object({
  securityQuestion1Id: z.string().min(1, RequiredMessage),
  securityAnswer1: auth.securityAnswer.schema.min(1, RequiredMessage),
  securityQuestion2Id: z.string().min(1, RequiredMessage),
  securityAnswer2: auth.securityAnswer.schema.min(1, RequiredMessage),
  securityQuestion3Id: z.string().min(1, RequiredMessage),
  securityAnswer3: auth.securityAnswer.schema.min(1, RequiredMessage),
});

export type ChangePasswordBlock = z.infer<typeof changePasswordBlock>;
export type SecurityQuestionsBlock = z.infer<typeof securityQuestionsBlock>;
